import { computed } from 'vue'
import { useSiteTemplate } from '@/composables/useSiteTemplate'
import { parseSiteConfigData } from '@/utils/siteSeo'

export const DEFAULT_CART_ENHANCEMENTS = Object.freeze({
  fullAmountGiftEnabled: false,
  relatedProductsEnabled: false,
})

function getSourceCartEnhancements(source) {
  const configData = source?.configData !== undefined
    ? parseSiteConfigData(source.configData)
    : parseSiteConfigData(source)

  const cartEnhancements = configData?.cartEnhancements
  return cartEnhancements && typeof cartEnhancements === 'object' && !Array.isArray(cartEnhancements)
    ? cartEnhancements
    : {}
}

export function resolveCartEnhancements(...sources) {
  const result = { ...DEFAULT_CART_ENHANCEMENTS }
  const resolvedKeys = new Set()

  for (const source of sources) {
    const cartEnhancements = getSourceCartEnhancements(source)

    for (const key of Object.keys(DEFAULT_CART_ENHANCEMENTS)) {
      if (!resolvedKeys.has(key) && typeof cartEnhancements[key] === 'boolean') {
        result[key] = cartEnhancements[key]
        resolvedKeys.add(key)
      }
    }
  }

  return result
}

export function useCartEnhancements() {
  const { currentSiteInfo, templateContext } = useSiteTemplate()

  const cartEnhancements = computed(() => resolveCartEnhancements(
    currentSiteInfo.value,
    templateContext.value,
  ))
  const fullAmountGiftEnabled = computed(
    () => cartEnhancements.value.fullAmountGiftEnabled,
  )
  const relatedProductsEnabled = computed(
    () => cartEnhancements.value.relatedProductsEnabled,
  )
  const hasEnabledCartEnhancement = computed(
    () => fullAmountGiftEnabled.value || relatedProductsEnabled.value,
  )

  return {
    cartEnhancements,
    fullAmountGiftEnabled,
    relatedProductsEnabled,
    hasEnabledCartEnhancement,
  }
}

export default useCartEnhancements
